"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_regional_option_1 = require("owa-regional-option");
var accountSubCategory = {
    key: 'account',
    titleStringKey: 'optionSubcategory_account',
    options: [owa_regional_option_1.RegionalOption],
};
exports.default = accountSubCategory;
//# sourceMappingURL=accountSubCategory.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-options-general/lib/config/accountSubCategory.js
// module id = 4917
// module chunks = 2